import React from 'react';

import { ReactComponent as Trough } from './trough.svg';

function FarmbotTroughIcon() {
  return <Trough width={18} style={{ marginTop: -4 }} />;
}

export default FarmbotTroughIcon;
